// Comments directly on a job, order, defect or document, instead of a separate chat about it. Anyone who can open the record can read them. Plain text. Works offline (queued).
import { useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import * as D from './data'
import { COMMENTS_NOTE, LIMITS, when } from './core'
import Translate from './Translate'

export default function RecordComments({ type, id, clientId }) {
  const { user, config } = useAuth()
  const cid = clientId || (config && config.id)
  const [rows, setRows] = useState(null), [text, setText] = useState(''), [err, setErr] = useState(''), [busy, setBusy] = useState(false)
  const load = () => D.comments(cid, type, id).then(setRows).catch(() => setRows(null))
  useEffect(() => { if (cid && id) load() }, [cid, type, id]) // eslint-disable-line
  if (!cid || !id || rows === null) return null   // not set up yet, or no right: nothing to show
  const add = async () => {
    const body = text.trim()
    if (!body) return
    setBusy(true); setErr('')
    try { await D.addComment(cid, type, id, user.id, body); setText(''); await load() } catch (e) { setErr(e.message) } finally { setBusy(false) }
  }
  return (
    <div data-comms-comments style={{ marginTop: 14, borderTop: '1px solid var(--line, var(--border))', paddingTop: 10 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>Comments</div>
      <div style={{ fontSize: 11.5, color: 'var(--muted)', marginBottom: 6 }}>{COMMENTS_NOTE}</div>
      {rows.map(c => (
        <div key={c.id} style={{ padding: '6px 0', fontSize: 13 }}>
          <div style={{ fontSize: 11.5, color: 'var(--muted)' }}>{c.author_name || 'You'}{(c.created_at || c.offline_at) ? ' · ' + when(c.created_at || c.offline_at) : ' · waiting to sync'}</div>
          <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: 'var(--text)' }}>{c.body}</div>
          <Translate kind="comment" id={c.created_at ? c.id : null} />
        </div>
      ))}
      <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
        <input aria-label="Add a comment" value={text} maxLength={LIMITS.comment} onChange={e => setText(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add() } }} placeholder="Add a comment" style={{ flex: 1, minWidth: 0, padding: '7px 9px', borderRadius: 8, border: '1px solid var(--line-2, var(--border))', background: 'var(--bg)', color: 'var(--text)', fontSize: 13 }} />
        <button type="button" className="btn" disabled={busy || !text.trim()} onClick={add}>Add</button>
      </div>
      {err && <div style={{ color: '#C0434A', fontSize: 12, marginTop: 4 }}>{err}</div>}
    </div>
  )
}
